<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('withdrawal.confirm.title') }}</h3>
        </div>

        <div class="mt-4">
            <div class="mt-4">
                <label for="to">{{ $t('withdrawal.confirm.address') }}</label>
                <h5 id="to">{{formData.to}}</h5>
                <div class="small">{{ $t('withdrawal.confirm.note') }}</div>
            </div>

            <div class="mt-4">
                <label for="value">{{ $t('withdrawal.confirm.amount') }}</label>
                <h5 id="value">{{formData.value}} {{formData.contract.name}}</h5>
            </div>

            <div class="text-center pt-3">
                <button @click.prevent="handleClickSubmit" type="button" class="btn btn-outline-secondary">{{
                    $t('withdrawal.confirm.submit') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import tokenService from './../../services/TokenService';

    export default {
        name: 'TokenWithdrawalConfirm',

        data() {
            return {
                formData: {
                    contract: null,
                    to: '',
                    value: ''
                }
            }
        },

        props: {
            contract: Object,
            to: String,
            value: Float64Array
        },

        mounted() {

        },

        created() {
            if (
                !this.$route.params.contract ||
                !this.$route.params.to ||
                !this.$route.params.value
            ) {
                this.$router.push({name: 'withdrawalToken'});
            } else {
                this.formData = this.$route.params;
            }
        },

        methods: {
            async handleClickSubmit() {
                try {
                    await tokenService.sendWithdrawalConfirmEmail({
                        contract_id: this.formData.contract.id,
                        to: this.formData.to,
                        value: this.formData.value
                    });
                    this.$router.push({name: 'withdrawalTokenConfirmEmailSent'});
                } catch (e) {
                    this.$router.push({name: 'withdrawalToken'});
                }
            }
        }
    }
</script>

<style>

</style>
